import { LevelType, SpaceType } from 'data/types';
import { isConditionedSpace } from './conditioned-spaces';
import { countsTowardFootprintSquareFootage } from './level-conditioning';
import { polygonArea } from './space-polygon';

export function getSpaceConditionedSquareFootage(space: SpaceType): number {
  if (!isConditionedSpace(space)) return 0;

  if (space.vertices && space.vertices.length >= 3) {
    return polygonArea(space.vertices);
  }

  if (space.width && space.length && space.width > 0 && space.length > 0) {
    return space.width * space.length;
  }

  const sqftAttr = space.attributes.find(
    (attr) => attr.code === 'square_footage'
  );
  if (sqftAttr?.value) {
    const value = Number(sqftAttr.value);
    if (!Number.isNaN(value)) return value;
  }

  return 0;
}

export function getStructureSpacesSquareFootage(
  structure: LevelType[]
): number {
  return structure.reduce((total, level) => {
    if (!countsTowardFootprintSquareFootage(level)) {
      return total;
    }
    return (
      total +
      level.sections.reduce(
        (sectionTotal, section) =>
          sectionTotal +
          section.spaces.reduce(
            (spaceTotal, space) =>
              spaceTotal + getSpaceConditionedSquareFootage(space),
            0
          ),
        0
      )
    );
  }, 0);
}
